import { render } from "./VnfAppliancesTab.vue?vue&type=template&id=6536c84a&scoped=true"
import script from "./VnfAppliancesTab.vue?vue&type=script&lang=js"
export * from "./VnfAppliancesTab.vue?vue&type=script&lang=js"

import "./VnfAppliancesTab.vue?vue&type=style&index=0&id=6536c84a&lang=scss&scoped=true"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536c84a"]])

export default __exports__